module.exports = __webpack_public_path__ + "img/hr-burner-mining-drill-W.e350cb8d.png";